import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { ButtonLoading } from '../../../../CommonComponents/OPL/Button/Button.loading';
import { TextLoading } from '../../../../CommonComponents/OPL/Text/Text.loading';
import { useIsMobile } from '../../../../_hooks/useIsMobile';
import { Header, Main, Wrapper } from './StartPage.styles';

interface Props {
  logo?: React.ReactNode;
}

export const StartPageLoading = ({ logo }: Props) => {
  const isMobile = useIsMobile();

  return (
    <Wrapper>
      {logo && <Header>{logo}</Header>}

      <Main>
        <Box>
          <TextLoading height="h2" width="90%" mx="auto" />
          <TextLoading height="h2" width="20%" mx="auto" mt="16" />
        </Box>

        <Box>
          <TextLoading height="body" width="100%" />
          <TextLoading height="body" width="95%" mt="8" />
          <TextLoading height="body" width="98%" mt="8" />
          <TextLoading height="body" width="20%" mt="8" />
        </Box>

        <TextLoading height="body" width="80%" />

        <ButtonLoading width="170px" size={isMobile ? 'large' : 'medium'} mx="auto" />
      </Main>
    </Wrapper>
  );
};
